var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGofinansLogoMobile = function SvgGofinansLogoMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 23,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C64F2",
    d: "M19.083 9.617h-4.902c-1.058 0-1.917.846-1.917 1.884s.863 1.88 1.917 1.88h2.986v2.929c0 1.038.862 1.884 1.916 1.884 1.055 0 1.917-.846 1.917-1.884v-4.809c0-1.038-.862-1.884-1.917-1.884"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1C64F2",
    d: "M11.726 19.236a8 8 0 0 1-2.26-.326l-.047-.014a5 5 0 0 1-.273-.087c-3.258-1.066-5.488-4.277-5.3-7.633l.036-.506c.443-3.941 3.852-6.91 7.925-6.91h7.273c1.058 0 1.916-.846 1.916-1.88S20.134 0 19.08 0h-7.354C5.261-.004.001 5.156.001 11.498c-.077 5.127 3.7 9.915 8.788 11.137.954.242 1.942.365 2.937.365 1.058 0 1.92-.846 1.92-1.88s-.862-1.884-1.92-1.884"
  })));
};
export default SvgGofinansLogoMobile;